import React from "react";
//@ts-ignore
import SimpleLineIcon from 'react-simple-line-icons';
//@ts-ignore
import StarRatingComponent from 'react-star-rating-component';
import { ListItemSmall } from "components/listItemSmall";
import { ButtonBase } from '@material-ui/core';
import "./ReviewItem.scss"

export interface ReviewItemProps {
    item: any;
    titleKey?: string;
    backgroundColor?: string;
    onClick?(item: any): void;
    cancelAmount?: boolean;
}

export interface ReviewItemState {

}

class ReviewItem extends React.Component<ReviewItemProps, ReviewItemState> {
    constructor(props: ReviewItemProps) {
        super(props);
        this.state = {};
    }

    handleClick(item: any) {
        if (this.props.onClick) {
            this.props.onClick(item);
        }
    }

    render() {
        return (
            <ButtonBase style={{
                outline: "none"
            }}
                disableRipple={false}
                focusRipple={true}
            >
                <div className="review-info" onClick={() => this.handleClick(this.props.item)} style={{ backgroundColor: this.props.backgroundColor }}>
                    {/* <div style={{ width: "92%" }}> */}
                        <div className="rating-info">
                          {/* <h2>{this.props.item.movers}</h2> */}
                          <h2>{this.props.item.numberofMen +' Movers, '+this.props.item.numberOfTrucks+' Truck'}</h2>
                            <StarRatingComponent
                                name="rate1"
                                starCount={5}
                                value={parseFloat( this.props.item.moveRating)}
                                emptyStarColor={'#BDBDBD'}
                                starColor={'#F2994A'}
                                onStarClick={() => { }}
                            />
                         
                            </div>
                            <div className="mover-detail">
                                <p><span>{this.props.item.toZip}</span></p>
                                {
                                    this.props.item.estimatedSqFt==="0"?
                                    <p>{this.props.item.moveSize}</p>:
                                    <p>{this.props.item.moveSize}, {this.props.item.estimatedSqFt} sqft</p>

                                }
                                
                            </div>
                    <div className="icon-right">
                        <SimpleLineIcon name="arrow-right" />
                    </div>
                               
                    {/* </div> */}
                </div></ButtonBase>
        );
    }
}

export default ReviewItem;